import { render, staticRenderFns } from "./ProdutosRodadaCompraBadge.vue?vue&type=template&id=48c9880e"
import script from "./ProdutosRodadaCompraBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutosRodadaCompraBadge.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports